import httpApi from '../api/httpApi';
import useSWR from 'swr';
import { RunningProcessResp } from '../../models/Admin/AdminProductsManagement';

const URL = 'api/v1/admin/bc-check';

const useAdminTaskRunSWR = () => {
    const fetch = (query): Promise<any> => {
        return httpApi
            .get<RunningProcessResp>(query)
            .then((res) => {
                return res.getData();
            })
            .catch((error) => {
                throw error;
            });
    };

    const { data, error, isLoading, mutate, isValidating } = useSWR(
        URL,
        fetch,
        {
            dedupingInterval: 30000, // 0.5min
            // refreshInterval: 60000,
            errorRetryCount: 3,
            // revalidateIfStale: false,
            // revalidateOnFocus: false,
            // revalidateOnReconnect: false
        }
    );

    return {
        runningProcess: data ? data : null,
        isLoading: isLoading,
        isError: error,
        forceRefresh: mutate,
        isValidating: isValidating,
    };
};

export default useAdminTaskRunSWR;
